import React, { useState } from 'react';
import { Button, Text, View } from "../../Components/Themed"
import type { AthleteProps, EventProps, LeagueProps, MatchProps, OrderProps, ParlayPositionProps, ParlayProps, TeamProps, TournamentProps } from "../../types"
import { useColors } from '../../constants/useColors';
import { Icons } from '../../Components';
import { MyActionHelpers } from '../api';
import { FlatList, Image } from 'react-native';
import { AthleteImage, TeamImage } from '../../Components/Jerseys';
import { MarketComponentHelpers } from '../../MarketComponents/api';

type ParlayRowProps = {
    market_type:'FOR_MONEY'|'FREE',
    leagues:LeagueProps[],
    events:EventProps[],
    tournaments:TournamentProps[],
    matches:MatchProps[],
    athletes:AthleteProps[],
    teams:TeamProps[],
    parlay:ParlayProps,
    parlay_orders:OrderProps[],
    parlay_positions:ParlayPositionProps[]
    width:number
}

const ParlayRow = ({ market_type, parlay, events, matches, tournaments, athletes, teams, parlay_orders, parlay_positions, leagues }:ParlayRowProps) => {
    const Colors = useColors();
    const [ expanded, setExpanded ] = useState(false);

    const cl = market_type == 'FOR_MONEY' ? '$' : 'E'
    const legs = parlay_orders.length
    const { stake, result_ind, winnings, potential_winnings } = MyActionHelpers.aggregatePositions(parlay, parlay_positions);
    const settled = result_ind ? true : false

    const renderLegResult = (result_ind?:'win'|'lose'|'draw'|'inprogress') => {
        switch(result_ind){
            case 'win':
                return <Icons.CheckIcon size={14} color={Colors.text.success} />
            case 'lose':
                return <Icons.CloseIcon size={14} color={Colors.text.error} />
            case 'draw':
                return <Icons.AlertIcon size={14} color={Colors.text.warning}/>
            default:
                return <Icons.ActivityIcon size={14} color={Colors.text.h1} />
        }
    }

    const renderOrders = (data:{ item:OrderProps, index:number }) => {
        const { contest_title, athlete, team, league } = MyActionHelpers.getDetailsForOrder(data.item, events, tournaments, matches, athletes, teams, leagues);
        const result_ind = data.item.positions[0]?.result_ind
        return (
            <View type='row' style={{ padding:10, borderBottomWidth:1, borderColor:Colors.borders.light }}>
                    {team ?
                    <TeamImage
                        team={team}
                        league={league}
                        size={10}
                    />
                    :athlete ?
                    <AthleteImage
                        athlete={athlete}
                        league={league}
                        size={18}
                    />
                    :league ?
                    <Image
                        source={{ uri: league.league_image }}
                        style={{ height:18, width:18 }}
                        resizeMode="cover"
                    />
                    :<></>
                    }
                    
                    <View transparent style={{ flex:1, marginLeft:8 }}>
                        <Text theme='h2'>{data.item.title}</Text>
                        <View transparent style={{ marginTop:3 }}>                            
                            <Text theme="description">{contest_title}</Text>
                        </View>
                    </View>
                    {data.item.resolution_status != 'closed' ?
                    <Button transparent style={{  marginRight:4, marginLeft:4, padding:10, flexDirection:'row', justifyContent:'center', alignItems:'center' }} onPress={() => console.log('ehy')}>
                        <Icons.ActivityIcon size={18} color={Colors.text.action} />
                        <Text theme="action"> View</Text>
                    </Button>
                    :<></>}
                    <View style={{ padding:10 }}>
                        <Text theme="description">{MarketComponentHelpers.getOddsLabel(data.item.odds)}</Text>
                    </View>
                    {renderLegResult(result_ind)}
                    {result_ind == 'draw' ? 
                    <View type='blur' style={{ position:'absolute', top:0, left:0, right:0, bottom:0, justifyContent:'center' }}>
                        <View style={{ borderBottomWidth:1, borderColor:Colors.borders.light, marginRight:20, marginLeft:20 }} />
                    </View>
                    :<></>}
                </View>
        )
    }


    return (
        <View transparent style={{ padding:10, borderBottomWidth:1, borderColor:Colors.borders.light, borderWidth:expanded?1:undefined }}>
            <View type='row' style={{ flexWrap:'wrap' }}>
                <Icons.ParlayIcon size={20} color={Colors.text.h1} />
                <Button transparent style={{ borderRadius:0, padding:0, borderLeftWidth:1, borderColor:Colors.borders.light, flexGrow:1, marginLeft:6, paddingLeft:6, minWidth:75 }} onPress={() => setExpanded(!expanded)}>
                    <Text theme='h1'>{parlay.name}</Text>
                    <Text theme='light' style={{ marginTop:3 }} color={Colors.text.action}>See {legs} legs</Text>
                </Button>
                <View style={{ margin:5, minWidth:40, justifyContent:'center', alignItems:'center' }}>
                    <Text theme='h1' color={Colors.text.warning}>{cl}{stake.toFixed(2)}</Text>
                    <Text theme='light' color={Colors.text.warning}>Risk</Text>
                </View>
                {settled ?
                <View style={{ margin:5, minWidth:40, justifyContent:'center', alignItems:'center' }}>
                    <Text theme='h1'>{cl}{winnings.toFixed(2)}</Text>
                    <Text theme='light'>Winnings</Text>
                </View>
                :
                <View style={{ margin:5, minWidth:40, justifyContent:'center', alignItems:'center' }}>
                    <Text theme='h1'>{cl}{potential_winnings.toFixed(2)}</Text>
                    <Text theme='light'>Potential</Text>
                </View>
                }
            </View>
            {expanded ?
            <View transparent style={{ padding:10 }}>
                <FlatList
                    data={parlay_orders}
                    keyExtractor={item => item.order_id.toString()}
                    renderItem={renderOrders}
                    key={`parlay_${parlay.parlay_id}_orders`}
                    />
            </View>
            :<></>}
        </View>
    )
}

export default ParlayRow